import { createContext } from "react";

interface AiBackgroundProcessingParams {
  defaultPollingIntervalMS: number;
}

export const AiBackgroundProcessingContext =
  createContext<AiBackgroundProcessingParams>({
    defaultPollingIntervalMS: 5 * 1000, // 5 seconds
  });
